import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/apiService';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = async (collegeEmail, otpCode) => {
    const data = await authService.verifyOTPAndLogin(collegeEmail, otpCode);
    setUser(data.user);
    return data;
  };

  const studentLogin = async (collegeEmail, password) => {
    const data = await authService.studentLogin(collegeEmail, password);
    console.log('📦 FRONTEND AuthContext: Full response:', data);
    console.log('📦 FRONTEND AuthContext: User data:', data.user);
    console.log('📦 FRONTEND AuthContext: User data keys:', Object.keys(data.user || {}));
    console.log('📦 FRONTEND AuthContext: User data stringified:', JSON.stringify(data.user, null, 2));
    setUser(data.user);
    localStorage.setItem('user', JSON.stringify(data.user));
    return data;
  };

  const staffLogin = async (collegeEmail, password) => {
    const data = await authService.staffLogin(collegeEmail, password);
    console.log('📦 Staff login response user data:', data.user);
    setUser(data.user);
    localStorage.setItem('user', JSON.stringify(data.user));
    return data;
  };

  const logout = async () => {
    await authService.logout();
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const value = {
    user,
    loading,
    login,
    studentLogin,
    staffLogin,
    logout,
    updateUser,
    isAuthenticated: !!user,
    isStaff: user?.userType === 'staff',
    isStudent: user?.userType === 'student'
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
